/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePenaltyDetailsCommand } from '../../models/update-penalty-details-command';
import { UpdatePenaltyDetailsCommandResult } from '../../models/update-penalty-details-command-result';

export interface ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Params {
      body?: UpdatePenaltyDetailsCommand
}

export function apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain(http: HttpClient, rootUrl: string, params?: ApiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePenaltyDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdatePenaltyDetailsCommandResult>;
    })
  );
}

apiPenaltyDetailsUpdatePenaltyDetailsPatch$Plain.PATH = '/api/PenaltyDetails/UpdatePenaltyDetails';
